import type { Trigger } from '../types';
import { ButtonClickTrigger } from './button-click';
import { ExitIntentTrigger } from './exit-intent';
import { TimeoutTrigger } from './timeout';
import { ScrollDepthTrigger } from './scroll-depth';
import { HashTrigger } from './hash';

const triggerMap: Record<string, new () => Trigger> = {
	button: ButtonClickTrigger,
	exit_intent: ExitIntentTrigger,
	timeout: TimeoutTrigger,
	scroll_depth: ScrollDepthTrigger,
	hash: HashTrigger,
};

export function createTrigger(type: string): Trigger | null {
	const Ctor = triggerMap[type];
	return Ctor ? new Ctor() : null;
}
